import DOMPurify from "dompurify";

export interface CdcImplicitConsentFieldProps extends React.HTMLAttributes<HTMLDivElement> {
  label: string;
}
// Renders a CDC implicit consent checkbox field
export function CdcImplicitConsentField({
  label,
}: Readonly<CdcImplicitConsentFieldProps>) {
  return (
    <div>
      <span
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize ? DOMPurify.sanitize(label) : "",
        }}
      />
    </div>
  );
}
